export const NodeTypeMapping = Object.freeze({
    TITLE: "title",
    ROOT: "root",
    BASE: "baseNode",
    INTERMEDIATE: "intermediateNode",
    DURATION: "durationNode",
    DATA: "dataNode",
    CONTAINER: "container",
    ANY: "any",
    NONE: null
})

export const BaseNodeMapping = Object.freeze({
    HYDRATES: "hydrates",
    PROTEIN: "protein",
    FAT: "fat",
    FIBER: "fiber"
})

export const errorMapping = Object.freeze({
    ONLY_ONE_TITLE_ALLOWED: "There can only be one title element",
    NO_TITLE: "It looks like this diagram does not have a title, please add a new title element",
    ONLY_ONE_ROOT_ALLOWED: "There can only be one root element",
    INVALID_METADATA: "This element's metadata has been changed and is no longer valid",
    DUPLICATED_NODE: "This element has been duplicated, delete one of the copies",
    SHOULD_NOT_HAVE_PARENT: "This element can have no parents, remove any incoming edges",
    SHOULD_HAVE_PARENT: "This element has to have a parent, connect it to another element via a new edge",
    WRONG_PARENT_TYPE: "This element cannot be a direct child of the given parent",
    MULTIPLE_PARENTS: "An element can only have one parent",
    INVALID_VALUE: "The introduced value is not valid",
    MISSING_CONTAINER: "This element should be placed in one of the swim-lanes so its value is properly set",
    STRAY_NODE: "All elements should be directly or indirectly connected to the root",
    INVALID_DIAGRAM: "ERROR: The diagram could not be saved. If you cannot properly see the error message press 'Enter' with no shape selected on the diagram"
})